// Sizes of layout
// TODO do ogarnięcia kiedy będzie potrzebne po raz pierwszy
// export const LAYOUT_SETTINGS = {
//     WRAPPER_WIDTH: '1180'
// };

// Breakpoints in layout
export const BREAKPOINTS: BreakpointsStringType = {
    DEFAULT: '0',
    XXS: '320',
    XS: '480',
    S: '768',
    SM: '960',
    M: '1260',
    ML: '1340',
    L: '1680',
    XL: '1920'
};
